module.exports = __webpack_public_path__ + "res/img_play.63d060a4122383b55836e11bddbc5bec.png";